import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import Fade from "@mui/material/Fade";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import PageLoadingBackdrop from "app/components/CommonPage/PageLoadingBackdrop";

const deleteSteps = {
  CONFIRM: "CONFIRM",
  DELETING: "DELETING",
  DELETE_COMPLETE: "DELETE_COMPLETE",
};

function ConfirmDeleteDialog(props) {
  const {
    open,
    handleClose,
    confirmTitle,
    confirmMessage,
    deleteCompleteTitle,
    deleteCompleteBtnLabel,
    deleteCompleteAction,

    deleteAction,
    handleDeleteSuccess,
    handleDeleteError,
  } = props;

  const [showStep, setShowStep] = useState(deleteSteps.CONFIRM);

  const executeAction = async () => {
    setShowStep(deleteSteps.DELETING);

    try {
      const res = await deleteAction();
      if (handleDeleteSuccess) handleDeleteSuccess(res);

      setShowStep(deleteSteps.DELETE_COMPLETE);
    } catch (error) {
      if (handleDeleteError) handleDeleteError(error);

      setShowStep(deleteSteps.CONFIRM);
    }
  };

  const handleConfirm = () => {
    if (showStep === deleteSteps.DELETING) return;
    executeAction();
  };

  const handleCloseDialog = () => {
    handleClose();

    setShowStep(deleteSteps.CONFIRM);
  };

  const handleBack = () => {
    if (showStep === deleteSteps.DELETING) return;
    handleCloseDialog();
  };

  return (
    <>
      <Dialog
        maxWidth="sm"
        open={open}
        onClose={() => showStep === deleteSteps.CONFIRM && handleClose()}
        aria-labelledby="responsive-dialog-title"
        classes={{ root: "bg-transparent" }}
        PaperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
            paddingTop: "40px",
          },
        }}
        TransitionComponent={Fade}
      >
        <div className="w-full flex flex-col items-center pt-16 pb-8 px-8 bg-white rounded-3xl relative min-w-[460px]">
          {showStep === deleteSteps.DELETE_COMPLETE ? null : (
            <div className="absolute w-20 h-20 -top-10 left-1/2 -translate-x-1/2 rounded-full overflow-hidden bg-red-500 flex items-center justify-center">
              <FontAwesomeIcon
                icon={faTriangleExclamation}
                size="3x"
                color="white"
              />
            </div>
          )}

          {showStep === deleteSteps.DELETE_COMPLETE ? (
            <>
              <h3 className="text-xl font-semibold mb-14">
                {deleteCompleteTitle}
              </h3>

              <div className="w-full flex items-center justify-center text-white text-base font-semibold gap-8">
                <button
                  onClick={deleteCompleteAction}
                  type="button"
                  className="px-4 py-1 rounded-md bg-[#667074] w-auto text-center"
                >
                  {deleteCompleteBtnLabel}
                </button>
              </div>
            </>
          ) : (
            <>
              <h3 className="text-xl font-semibold mb-3">{confirmTitle}</h3>

              <p className="text-lg font-base mb-8">{confirmMessage}</p>

              <div className="w-full flex items-center justify-center text-white text-base font-semibold gap-8">
                <button
                  onClick={handleBack}
                  type="button"
                  className="px-4 py-1 rounded-md bg-[#667074] w-32 text-center"
                >
                  キャンセル
                </button>
                <button
                  onClick={handleConfirm}
                  type="button"
                  className="px-4 py-1 rounded-md bg-red-500 w-32 text-center"
                >
                  進む
                </button>
              </div>
            </>
          )}
        </div>
      </Dialog>

      <PageLoadingBackdrop open={showStep === deleteSteps.DELETING} />
    </>
  );
}

export default ConfirmDeleteDialog;
